import type { GeoData } from '@/api/geo'
import { useQuery } from '@tanstack/react-query'
import { client } from '../lib/api-client'

const TWENTY_FOUR_HOURS = 24 * 60 * 60 * 1000

export function useGeo() {
  return useQuery<GeoData>({
    queryKey: ['geo'],
    queryFn: async () => {
      const response = await client.api.v1.geo.$get()
      if (!response.ok) throw new Error('Failed to fetch geo')
      return response.json() as Promise<GeoData>
    },
    staleTime: TWENTY_FOUR_HOURS,
    gcTime: TWENTY_FOUR_HOURS,
    refetchOnWindowFocus: false,
  })
}
